var React = require('react');

function SuccessFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0C10.746 0 0 10.746 0 24s10.746 24 24 24 24-10.746 24-24S37.254 0 24 0zm13.177 14.587a1.5 1.5 0 10-2.354-1.86L19.137 32.573l-.017.022a.599.599 0 01-.974-.028l-.02-.03-4.9-6.954a1.5 1.5 0 10-2.452 1.728l4.891 6.941a3.599 3.599 0 004.98.971l.006-.004a3.64 3.64 0 00.847-.795l15.679-19.837z"}));
}

SuccessFilled.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = SuccessFilled;

SuccessFilled.default = SuccessFilled;
